import { http } from '.';

export const deleteStrokeDataSession = async (sessionId: number): Promise<void> => {
  await http.delete(`/stroke-sessions/${sessionId}/`);
};

